var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    className: "circle",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C5.79 0.75 0.75 5.79 0.75 12C0.75 18.21 5.79 23.25 12 23.25C18.21 23.25 23.25 18.21 23.25 12C23.25 5.79 18.21 0.75 12 0.75ZM12 18.75C11.175 18.75 10.5 18.075 10.5 17.25C10.5 16.425 11.175 15.75 12 15.75C12.825 15.75 13.5 16.425 13.5 17.25C13.5 18.075 12.825 18.75 12 18.75ZM13.7175 7.1175L13.215 13.1325C13.1625 13.7625 12.6375 14.25 12 14.25C11.3625 14.25 10.8375 13.7625 10.785 13.1325L10.2825 7.1175C10.2 6.1125 10.9875 5.25 12 5.25C12.96 5.25 13.725 6.03 13.725 6.975C13.725 7.02 13.725 7.0725 13.7175 7.1175Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRounded);
export default __webpack_public_path__ + "static/media/error-rounded.72ea29a89a0c6cd95eb43e983af7f18f.svg";
export { ForwardRef as ReactComponent };